export enum Published {
  Yes = '1',
  No = '0',
}